import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { submitData } from "../actions/map";
import { Layer } from "../../interfaces/layer";

export interface Files {
  shp?: File | null;
  shx?: File | null;
  dbf?: File | null;
  dxf?: File | null;
}

export interface SubmitDataParams {
  layer: Layer;
  files: Files;
  coordinatesSystem: string | null;
}

interface UploadState {
  selectedFiles: Files;
  selectedCoordinatesSystem: string | null;
  selectedLayer: Layer | null;
  responseData: any;
  error: string | null;
  loading: boolean;
}

const initialState: UploadState = {
  selectedFiles: { shp: null, shx: null, dbf: null, dxf: null },
  selectedCoordinatesSystem: null,
  selectedLayer: null,
  responseData: null,
  error: null,
  loading: false,
};

export const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setSelectedCoordinatesSystem: (state, action: PayloadAction<string>) => {
      state.selectedCoordinatesSystem = action.payload;
    },
    setSelectedLayer: (state, action: PayloadAction<Layer | null>) => {
      state.selectedLayer = action.payload;
    },
    setFiles: (state, action: PayloadAction<Files>) => {
      state.selectedFiles = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitData.pending, (state: UploadState) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitData.fulfilled, (state: UploadState, action: PayloadAction<any>) => {
        state.loading = false;
        state.responseData = action.payload;
      })
      .addCase(submitData.rejected, (state: UploadState, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSelectedCoordinatesSystem, setSelectedLayer, setFiles, setError } = uploadSlice.actions;

export default uploadSlice.reducer;

